import React from 'react';
import PropTypes from 'prop-types';

import Dropdown from './index';

import stylesheet from './Dropdown.module.css';

const DropdownButton = ({ href, label, onClick }) => {
  return (
    <Dropdown.Item>
      {href ? (
        <a className={stylesheet.button} href={href}>
          {label}
        </a>
      ) : (
        <button className={stylesheet.button} onClick={onClick} type="button">
          {label}
        </button>
      )}
    </Dropdown.Item>
  );
};

DropdownButton.propTypes = {
  href: PropTypes.string,
  label: PropTypes.string.isRequired,
  onClick: PropTypes.func,
};

export default DropdownButton;
